import PropTypes from 'prop-types';
import React from 'react';
import { DistanceCell } from 'modules/Common/Details';
import { injectIntl } from 'react-intl';
const Text = ({ text, showDistance, item, intl }) => {
  const t = intl.messages.modules.googleMapsLink;
  if (text) {
    return text;
  }

  if (showDistance) {
    return <DistanceCell {...item} />;
  }

  return t.view_route_on_map;
};

Text.propTypes = {
  text: PropTypes.string,
  showDistance: PropTypes.bool,
  item: PropTypes.object,
};

export default injectIntl(Text);
